import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-i-casino',
  templateUrl: './i-casino.component.html',
  styleUrls: ['./i-casino.component.css']
})
export class ICasinoComponent implements OnInit {
  modalRef?: BsModalRef;
  public api = api;
  public env = environment;
  public data: any;
  public iframeUrl: any = '';
  public gameName: any = '';

  constructor(public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    // this._shared.sharedTabCasinoI.subscribe((data: any) => {
    //   if (data)
    //     this.getData();
    // });
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoIList}`).subscribe(
      (res) => {
        if (res.status == true) {
          let dt: any[] = [];
          Object.keys(res.data.tables).forEach((key) => {
            let dataDt: any[] = [];
            Object.keys(res.data.tables[key]).forEach((key1) => {
              dataDt.push({
                'name': key1,
                'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
                'data': res.data.tables[key][key1]
              });
            });
            dt.push({
              'name': key,
              'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
              'data': dataDt
            });
          });
          res.data.tables = dt;

          this.data = res.data;
        }
      },
      (err) => {
        console.log(err);
      });
    // this.getServices().Get(`${this.env.baseUrl + this.api.casinoIList}`).subscribe(
    //   (res) => {
    //     if (res.status == true) {
    //       // generate unique key value object
    //       let dataDtKeys: any[] = [];
    //       Object.keys(res.data.providers).forEach((key) => {
    //         dataDtKeys = [...dataDtKeys, ...Object.keys(res.data.providers[key])]
    //       });
    //       dataDtKeys = [...new Set(dataDtKeys)];
    //       let dataDt = dataDtKeys.reduce((key, value) => {
    //         return { ...key, [value]: [] };
    //       }, {});
    //
    //       // append data to appropriate key
    //       Object.keys(res.data.providers).forEach((key) => {
    //         Object.keys(res.data.providers[key]).forEach((key1) => {
    //           dataDt[key1] = [...dataDt[key1], ...res.data.providers[key][key1]];
    //         });
    //       });
    //
    //       // final data to display converion
    //       let dt: any[] = [];
    //       Object.keys(dataDt).forEach((key) => {
    //         dt.push({
    //           'name': key,
    //           'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
    //           'data': dataDt[key]
    //         });
    //       });
    //
    //       res.data.providers = dt;
    //       this.data = res.data;
    //     }
    //   },
    //   (err) => {
    //     console.log(err);
    //   });
  }

  openModal(template: TemplateRef<any>, item: any, name: any) {
    console.log(item);
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoITbl}/${item.id}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.iframeUrl = this._common.secureUrl(res.data.iframe);
          this.gameName = name;

          this.modalRef = this.modalService.show(template,
            Object.assign({}, { class: `casino-modal-size ${this.env.modalClass}` }));
        }
      },
      (err) => {
        console.log(err);
      });

  }

  closeModal() {
    this.modalRef?.hide();
    this.iframeUrl = '';
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
